import { j as i } from "./jsx-runtime-944c88e2.js";
import { forwardRef as f } from "react";
import { F as x } from "./FormElement-65f04cfd.js";
import { L as j, H as F, I as h } from "./form-2514c6d8.js";
function R(r) {
  const a = f(function({ label: t, hint: l, validateOnSubmit: m, hasAttemptedSubmit: u, ...e }, s) {
    const c = e.required && !e.value ? "Field is Required" : "", n = e.validationMessage || c, d = !n || (m ? !u : !e.touched);
    return /* @__PURE__ */ i.jsxs(x, { children: [
      t && /* @__PURE__ */ i.jsx(j, { editorId: e.id, editorValid: d, editorRef: s, required: e.required, children: t }),
      /* @__PURE__ */ i.jsx("div", { children: /* @__PURE__ */ i.jsx(r, { ...e, valid: d, ref: s }) }),
      d ? /* @__PURE__ */ i.jsx(F, { children: l }) : /* @__PURE__ */ i.jsx(h, { children: n })
    ] });
  }), o = r.displayName || r.name || "missingName";
  return a.displayName = `${o}FormField`, a;
}
export {
  R as w
};
